/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed percentage change between two values`)
};

const es_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio porcentual con signo entre dos valores`)
};

const de_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorzeichenbehaftete prozentuale Veränderung zwischen zwei Werten`)
};

const nl_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentageverandering met teken tussen twee waarden`)
};

const fr_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variation en pourcentage signée entre deux valeurs`)
};

const it_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variazione percentuale con segno tra due valori`)
};

const pt_br2_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variação percentual com sinal entre dois valores`)
};

const pt_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variação percentual com sinal entre dois valores`)
};

const ja_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの値の間の符号付きパーセント変化`)
};

const zh_pct_nav_change_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个数值之间带符号的百分比变化`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_change_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_change_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_change_desc", locale)
	if (locale === "en") return en_pct_nav_change_desc(inputs)
	if (locale === "es") return es_pct_nav_change_desc(inputs)
	if (locale === "de") return de_pct_nav_change_desc(inputs)
	if (locale === "nl") return nl_pct_nav_change_desc(inputs)
	if (locale === "fr") return fr_pct_nav_change_desc(inputs)
	if (locale === "it") return it_pct_nav_change_desc(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_change_desc(inputs)
	if (locale === "pt") return pt_pct_nav_change_desc(inputs)
	if (locale === "ja") return ja_pct_nav_change_desc(inputs)
	return zh_pct_nav_change_desc(inputs)
};